"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUsers = void 0;
var _types = require("./types");
var getUsers = exports.getUsers = function getUsers(_users) {
  var shouldCheckPresenceBeforeFetch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    type: _types.GET_USERS,
    _users,
    shouldCheckPresenceBeforeFetch
  };
};